import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "modal__inner" };
import { XIcon } from "@heroicons/vue/outline";
import { computed } from "vue";
import { Teleport as teleport_ } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        allowClose: { type: Boolean, default: false },
        importance: { default: "normal" },
        show: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const Teleport = teleport_;
        const className = computed(() => [
            "modal",
            props.show ? "modal--show" : undefined,
            `modal--importance-${props.importance}`,
        ]
            .filter((c) => c)
            .join(" "));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(Teleport)), { to: "body" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(_unref(className))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            (props.allowClose)
                                ? (_openBlock(), _createBlock(_unref(XIcon), {
                                    key: 0,
                                    class: "modal__close",
                                    onClickPassive: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:show', false)))
                                }))
                                : _createCommentVNode("", true),
                            _renderSlot(_ctx.$slots, "default")
                        ])
                    ], 2)
                ]),
                _: 3
            }));
        };
    }
});
